"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapConfig = exports.googleAnalyticsCode = exports.auth = exports.scConfig = exports.api = exports.envs = void 0;

var _default2 = _interopRequireDefault(require("./default"));

var _local = _interopRequireDefault(require("./local"));

var _dev = _interopRequireDefault(require("./dev"));

var _test = _interopRequireDefault(require("./test"));

var _production = _interopRequireDefault(require("./production"));

var _qa = _interopRequireDefault(require("./qa"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var envs = {
  LOCAL: 'local',
  DEV: 'development',
  QA: 'qa',
  TEST: 'test',
  PRODUCTION: 'prod'
}; // eslint-disable-next-line

exports.envs = envs;
var selectedConfig = null;

switch (process.env.REACT_APP_ENV) {
  case envs.LOCAL:
    selectedConfig = _local.default;
    break;

  case envs.DEV:
    selectedConfig = _dev.default;
    break;

  case envs.TEST:
    selectedConfig = _test.default;
    break;

  case envs.QA:
    selectedConfig = _qa.default;
    break;

  case envs.PRODUCTION:
    selectedConfig = _production.default;
    break;

  default:
    selectedConfig = _default2.default;
}

var _selectedConfig = selectedConfig,
    api = _selectedConfig.api,
    scConfig = _selectedConfig.scConfig,
    auth = _selectedConfig.auth,
    googleAnalyticsCode = _selectedConfig.googleAnalyticsCode,
    mapConfig = _selectedConfig.mapConfig;
exports.mapConfig = mapConfig;
exports.googleAnalyticsCode = googleAnalyticsCode;
exports.auth = auth;
exports.scConfig = scConfig;
exports.api = api;
var _default = selectedConfig;
exports.default = _default;